import React, { useState } from 'react'
import PropTypes from 'prop-types'

import NextIcon from '../../../../assets/svg/NextIcon'
import PreviousIcon from '../../../../assets/svg/PreviousIcon'
import StepIcon from '../../../../assets/svg/StepIcon'
import styles from '../HistoricalImagery.module.scss'

export function ImageryControls(props) {
  const { value = 0, values = [] } = props.stepper
  const [iconHoverState, setIconHoverState] = useState('')

  const handlePreviousClick = () => {
    if (value > 0) {
      props.handleStepperClick(value - 1)
    }
  }
  const handleNextClick = () => {
    if (value < values.length - 1) {
      props.handleStepperClick(value + 1)
    }
  }

  const handleStepItemClick = index => {
    props.handleStepperClick(index)
  }

  const handleMouseEnter = type => {
    setIconHoverState(type)
  }
  const handleMouseLeave = () => {
    setIconHoverState('')
  }

  return (
    <div className={styles.controlsContainer}>
      <div className={styles.controlsMainTopText}>
        <p>Available Images</p>
      </div>
      <div className={styles.controlsMain}>
        <div className={styles.leftControls}>
          <PreviousIcon
            disabled={value === 0}
            hovered={iconHoverState === 'prev'}
            onClick={handlePreviousClick}
            onMouseLeave={handleMouseLeave}
            onMouseEnter={() => handleMouseEnter('prev')}
          />
        </div>
        <div className={styles.centerControls}>
          {values.map(il => {
            return (
              <StepIcon
                active={value === il}
                hovered={iconHoverState === `step-${il}`}
                key={il}
                onClick={() => handleStepItemClick(il)}
                onMouseEnter={() => handleMouseEnter(`step-${il}`)}
                onMouseLeave={handleMouseLeave}
              />
            )
          })}
        </div>
        <div className={styles.rightControls}>
          <NextIcon
            disabled={value === values.length - 1}
            hovered={iconHoverState === 'next'}
            onClick={handleNextClick}
            onMouseLeave={handleMouseLeave}
            onMouseEnter={() => handleMouseEnter('next')}
          />
        </div>
      </div>
      <div className={styles.controlsMainBottomText}>
        <p>Oldest</p>
        <p>Newest</p>
      </div>
    </div>
  )
}

ImageryControls.propTypes = {
  isControlDisabled: PropTypes.bool,
  stepper: PropTypes.object,
  // functions
  handleItemClick: PropTypes.func,
  handleStepperClick: PropTypes.func
}

export default ImageryControls
